/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The HospitalsHospital model module.
 * @module model/HospitalsHospital
 * @version v0.3
 */
export default class HospitalsHospital {
  /**
   * Constructs a new <code>HospitalsHospital</code>.
   * @alias module:model/HospitalsHospital
   * @class
   * @param name {String} 
   */
  constructor(name) {
    this.name = name;
  }

  /**
   * Constructs a <code>HospitalsHospital</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/HospitalsHospital} obj Optional instance to populate.
   * @return {module:model/HospitalsHospital} The populated <code>HospitalsHospital</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new HospitalsHospital();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} name
 */
HospitalsHospital.prototype.name = undefined;

